import React from "react";
import { Row, Col, Alert, Form, Card, Button} from "react-bootstrap";
import { AiOutlineBarcode } from "react-icons/ai";
class _renderDeviceInfo extends React.Component {
    render() {
        return (
            <>
                <Row className="mb-2">
                    <Col>
                        <h6><strong>Identifikace zařízení</strong></h6>
                    </Col>
                </Row>
                {this.props.deviceInfo.alert.show && (
                    <Row className="mb-2">
                        <Col>
                            <Alert variant={this.props.deviceInfo.alert.variant}>
                                {this.props.deviceInfo.alert.text}
                            </Alert>
                        </Col>
                    </Row>
                )}
                {this.props.deviceInfo.set && (
                    <>
                        <Row className="mb-2">
                            <Col>
                                <Card bg="uni">
                                    <Row className="mt-3 mb-3 ms-3 me-3">
                                        <Col xs={12} className="align-items-center">
                                            <Row>
                                                <Col xs={1} className="d-flex justify-content-center align-items-center">
                                                    <AiOutlineBarcode className="fs-20" />
                                                </Col>
                                                <Col xs={11}>
                                                    <Row>
                                                        <Col xs={6}>
                                                            <Form.Text className="me-4">IMEI:</Form.Text>
                                                            <span>{this.props.deviceInfo.imei}</span>

                                                        </Col>
                                                        <Col xs={6}>
                                                            <Form.Text className="me-4">S/N:</Form.Text>
                                                            <span>{this.props.deviceInfo.sn}</span>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
                {!this.props.deviceInfo.set && (
                    <>
                        <Row className="mb-2">
                            <Col>
                                <Card bg="uni">
                                    <Row className="mt-3 mb-3 ms-3 me-3">
                                        <Col xs={12} className="align-items-center">
                                            <Row>
                                                <Col xs={1} className="d-flex justify-content-center align-items-center">
                                                    <AiOutlineBarcode className="fs-20" />
                                                </Col>
                                                <Col xs={11}>
                                                    <Row>
                                                        <Col xs={6}>
                                                            <Form.Control onChange={(e) => this.props.setState({ deviceInfo: { ...this.props.deviceInfo, imei: e.target.value } })} type="text" />
                                                            <Form.Text>IMEI</Form.Text>
                                                        </Col>
                                                        <Col xs={6}>
                                                            <Form.Control onChange={(e) => this.props.setState({ deviceInfo: { ...this.props.deviceInfo, sn: e.target.value } })} type="text" />
                                                            <Form.Text>S/N</Form.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} className="d-flex justify-content-end">
                                            <Button variant="success" size="sm" onClick={this.props.confirmDeviceInfo}>Potvrdit</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
            </>
        )
    }
}
export default _renderDeviceInfo;